import React, { memo } from 'react';
import PropTypes from 'prop-types';

const PageHeader = ({ title, years, t }) => {
    return (
        <div className="pageName">
            <div className="pageTitle">{t(title)}</div>
            {years.map((year) => (
                <div key={year} className="pageTitleMetai desktop">
                    {year}
                </div>
            ))}
        </div>
    );
};

PageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    years: PropTypes.arrayOf(PropTypes.string).isRequired,
    t: PropTypes.func.isRequired
};

export default memo(PageHeader);
